import { render, staticRenderFns } from "./orderInventoryDialog.vue?vue&type=template&id=21ee8478"
import script from "./orderInventoryDialog.vue?vue&type=script&lang=js"
export * from "./orderInventoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports